module.exports = __webpack_public_path__ + "img/3.528170a4.png";